import { render, staticRenderFns } from "./StarterFooter.vue?vue&type=template&id=2941afe5&scoped=true&"
import script from "./StarterFooter.vue?vue&type=script&lang=js&"
export * from "./StarterFooter.vue?vue&type=script&lang=js&"
import style0 from "./StarterFooter.vue?vue&type=style&index=0&id=2941afe5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2941afe5",
  null
  
)

export default component.exports